import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

export const simplifyFiltersOnPLPSelector = createSelector(
    testTargetOffersSelector,
    offers => offers.simplifyFiltersOnPLP || Empty.Object
);
